/**
 * Zopup - Product Catalogue API
 * Zopup - Product Catalogue API
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

// Third party library imports
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

// Zopup library imports
import { 
    RegionProfileDto,
    RegionProfileDtoListWebApiResponse,
    RegionProfileDtoWebApiResponse,
    RegionProfileUpdateCommand,
    BooleanWebApiResponse,
} from '@zopup/zop-types';

// Internal project imports
import { BaseService } from '../api.base.service';
import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { PRODUCT_CATALOGUE_API_BASE_PATH } from '../api-tokens';

@Injectable({
    providedIn: 'root'
})
export class RegionProfileService extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Inject(PRODUCT_CATALOGUE_API_BASE_PATH) private apiBasePath: string
    ) {
        super();
        this.basePath = this.apiBasePath;
        this.configuration.basePath = this.basePath;
    }

    /**
     * Get region profiles
     * 
     * @param orderBy 
     * @param isOrderByDescending 
     * @param searchText 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regionProfilesGet(orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'body', reportProgress?: boolean): Observable<RegionProfileDtoListWebApiResponse>;
    public regionProfilesGet(orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RegionProfileDtoListWebApiResponse>>;
    public regionProfilesGet(orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RegionProfileDtoListWebApiResponse>>;
    public regionProfilesGet(orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', <any>element);
            })
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', <any>isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', <any>searchText);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RegionProfileDtoListWebApiResponse>('get',`${this.basePath}/RegionProfiles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update region profile
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regionProfilesPut(body?: RegionProfileUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<RegionProfileDtoWebApiResponse>;
    public regionProfilesPut(body?: RegionProfileUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RegionProfileDtoWebApiResponse>>;
    public regionProfilesPut(body?: RegionProfileUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RegionProfileDtoWebApiResponse>>;
    public regionProfilesPut(body?: RegionProfileUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RegionProfileDtoWebApiResponse>('put',`${this.basePath}/RegionProfiles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete region profile by region
     * 
     * @param region 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regionProfilesRegionDelete(region: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public regionProfilesRegionDelete(region: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public regionProfilesRegionDelete(region: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public regionProfilesRegionDelete(region: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (region === null || region === undefined) {
            throw new Error('Required parameter region was null or undefined when calling regionProfilesRegionDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/RegionProfiles/${encodeURIComponent(String(region))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get region profile by region
     * 
     * @param region 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regionProfilesRegionGet(region: string, observe?: 'body', reportProgress?: boolean): Observable<RegionProfileDtoWebApiResponse>;
    public regionProfilesRegionGet(region: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RegionProfileDtoWebApiResponse>>;
    public regionProfilesRegionGet(region: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RegionProfileDtoWebApiResponse>>;
    public regionProfilesRegionGet(region: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (region === null || region === undefined) {
            throw new Error('Required parameter region was null or undefined when calling regionProfilesRegionGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RegionProfileDtoWebApiResponse>('get',`${this.basePath}/RegionProfiles/${encodeURIComponent(String(region))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
